module.exports = __webpack_public_path__ + "static/media/streck.7c395509.mp3";